import React from 'react'
import './style.css'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'

class Gallery extends React.Component {
  render() {
    const images = [
      {
        original: '/img/gallery/closed-sales1.jpg',
        thumbnail: '/img/gallery/closed-sales1-thumb.jpg',
      },
      {
        original: '/img/gallery/closed-sales2.jpg',
        thumbnail: '/img/gallery/closed-sales2-thumb.jpg',
      },

      {
        original: '/img/gallery/closed-sales3.jpg',
        thumbnail: '/img/gallery/closed-sales3-thumb.jpg',
      },
      {
        original: '/img/gallery/closed-sales4.jpg',
        thumbnail: '/img/gallery/closed-sales4-thumb.jpg',
      },
      {
        original: '/img/gallery/closed-sales5.jpg',
        thumbnail: '/img/gallery/closed-sales5-thumb.jpg',
      },
    ]
    return (
      <section id="gallery">
        <div className="container" style={{ marginTop: '100px' }}>
          <div className="row">
            <div className="col-12">
              <div className="headtest mb-5 text-center">
                <span>OUR</span>
                <h2>Happy Clients</h2>
              </div>
              <div className="photoGrid">
                <div className="row">
                  <div className="col-12">
                    <ImageGallery items={images} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Gallery
